import Vue from "vue";
import IModel from "../interfaces/modelInterfaces";
import scrollToElement from "../helpers/scrollToElement";

export default function routerSelectedMixinFactory(itemPropKey: string, containerClass: string, queryKey: string = 'selectedId') {
  return Vue.extend({
    mounted() {
      this.routerSelectThisItem();
      if (this.routeSelectedItem.isSelected) {
        this.scrollToElement();
        if (this.$route.query[queryKey] !== this.routeSelectedItem.client_id) {
          this.replaceIdInRoute(null);
        }
      }
    },
    computed: {
      routeSelectedItem(): IModel {
        return this[itemPropKey];
      },
    },
    methods: {
      routerSelectThisItem() {
        if (!this.disabled && !this.routeSelectedItem.isSelected && this.$route.query[queryKey] === this.routeSelectedItem.client_id) {
          if (document.activeElement) {
            let $activeEl = $(document.activeElement);
            let $routeSelectedItem = $activeEl.closest(containerClass);
            if ($routeSelectedItem[0] !== this.$el) {
              $(document.activeElement).blur();
            }
          }
          this.setSelected(this.routeSelectedItem);
        }
      },
      selectThisItem(event) {
        this.routerSelectThisItem(event)
      },
      replaceIdInRoute($event, scroll: boolean = false): void {
        if (!this.disabled) {
          this.replaceRouteQuery({[queryKey]: this.routeSelectedItem.client_id});
          if (scroll) {
            this.$store.commit('interfaceStore/peek', {modelId: this.routeSelectedItem.client_id});
          }
        }
      },
      setSelected(item: IModel): void {
        if (import.meta.env.MODE === 'development') {
          throw new Error('Method not implement: Please provide a setSelected method in the Vue component.')
        }
      },
      scrollToElement(callback?): void {
        scrollToElement({
          $el: $(this.$el),
          $container: $(this.$el).closest('.work-area.scroll-area, .workarea.scroll-area'),
          relative: true,
          $horizontalContainer: $(this.$el).closest('.scroll-area'),
          offset: -50,
          callback,
        });
      },
    },
    watch: {
      $route(to, from) {
        if (this.$route.query[queryKey] === this.routeSelectedItem.client_id) {
          this.routerSelectThisItem();
        }
      },
    },
    beforeDestroy() {
      if (this.routeSelectedItem.isSelected) this.routeSelectedItem.deselect()
    }
  });
}